<template>
  <form @submit.prevent="reset" @keydown="form.onKeydown($event)" class="reset-password" autocomplete="off">

    <h1 class="reset-password__title">{{ $t('reset_password_header') }}</h1>
    <alert-success :form="form" :message="status"></alert-success>

    <label class="reset-password__label">{{ $t('email') }}</label>
    <input v-model="form.email"
           v-validate="'required|email'"
           type="email"
           name="email"
           autocomplete="off"
           class="reset-password__input"
           :class="{'is-danger': errors.has('email') }">
    <span v-show="errors.has('email')" class="danger-message">{{ errors.first('email') }}</span>

    <label class="reset-password__label">{{ $t('password') }}</label>
    <input v-model="form.password"
           v-validate="'required|confirmed:password_confirmation|min:6'"
           autocomplete="off"
           type="password"
           name="password"
           class="reset-password__input"
           :class="{'is-danger': errors.has('password') }">
    <span v-show="errors.has('password')" class="danger-message">{{ errors.first('password') }}</span>

    <label class="reset-password__label">{{ $t('confirm_password') }}</label>
    <input v-model="form.password_confirmation"
           autocomplete="off"
           type="password"
           name="password_confirmation"
           class="reset-password__input"
           :class="{'is-danger': errors.has('password_confirmation') }">
    <span v-show="errors.has('password_confirmation')" class="danger-message">{{ errors.first('password_confirmation') }}</span>

    <v-button :loading="form.busy" :disabled="errors.has('password_confirmation') || errors.has('password')" class="reset-password__button button button--blue">{{ $t('reset_password') }}</v-button>
  </form>
</template>

<script>
import Form from 'vform'

export default {
  metaInfo () {
    return { title: this.$t('reset_password') }
  },

  data: () => ({
    status: '',
    form: new Form({
      token: '',
      email: '',
      password: '',
      password_confirmation: ''
    })
  }),

  methods: {
    async reset () {
      this.form.token = this.$route.params.token;

      const { data } = await this.form.post('/api/password/reset');

      this.status = data.status;
      this.form.reset();
      this.$router.push({ name: 'password.success' });
    }
  }
}
</script>
